import React from 'react';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import closeIcon from '../../../public/img/close-icon.svg';
import { humanizeNumber } from '../../helpers/formatters';

const factoids = [
  {
    key: 'population2019',
    label: 'people',
    format: 'number',
    iconName: 'people',
  },
  {
    key: 'averageIncome2017',
    label: 'average income',
    format: 'number',
    iconName: 'income',
  },
  {
    key: 'medianAge2019',
    label: 'median age',
    format: 'number',
    iconName: 'age',
  },
];

const MapBanner = ({ council, comparing, onCloseClicked }) => {
  return (
    <div
      className={`${styles.banner} ${styles.mapBanner}`}
      data-comparing={comparing}
    >
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" style={{ height: 10, width: 10 }} />
      </button>
      <h2 className={styles.mapBannerHeading}>{council.name}</h2>
      <div className={styles.mapBannerDataRow}>
        {factoids.map((f, i) => {
          return (
            <div
              key={f.key}
              className={styles.mapBannerDataBlockWrapper}
              style={{ marginRight: i < factoids.length - 1 ? 40 : 0 }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/${f.iconName}-icon.svg`}
                alt={`${f.iconName} icon`}
                width="35"
                height="46"
              />
              <div className={styles.mapBannerDataBlockContent}>
                <div className={styles.mapBannerDataNumber}>
                  {humanizeNumber(council[f.key], f.format)}
                </div>
                <span>{f.label}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.mapBannerLegend}>
        <span> This demographic data was sourced from the</span>
        <a
          className={styles.externalLink}
          href="http://www.abs.gov.au/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Australian Bureau of Statistics{' '}
        </a>
        and represents the average of median statistics for the local government
        areas that make up this region.
      </div>
    </div>
  );
};

MapBanner.propTypes = {
  council: PropTypes.object,
  comparing: PropTypes.bool,
};

export default MapBanner;



// WEBPACK FOOTER //
// ./src/components/map-container/map-banner.js